/*
*
* An interface to the simple relay server for multiplayer games (SMP).
*
*/
define('multiplayer',['logger'], function(Logger) {
  return {
    room: {},
    appid: '',
    appsession: '',
    callback: null,
    session: '',
    userid: '',
    nodes: [['playtomic1.nl1.id.net', 3201], ['playtomic2.nl1.id.net', 3201]],

    //nodes: [['192.168.56.101', 3201]],
    host: '',
    port: 0,
    proto: (document.location.protocol === 'https:' ? 'wss://' : 'ws://'),
    msgQue: [],
    socket: null,
    _message: '',
    reconnects: 0,
    reconnectDelay: 5000,
    switchingServer: false,
    timedout: false,
    debugLevel: 2,

    open: function(appid, appsession, callback) {
      if (!appid) {
        Logger.log('SMP: missing appid');
      }

      if (!appsession) {
        Logger.log('SMP: missing Game API appsession');
      }

      this.appid = appid;
      this.appsession = appsession;
      this.callback = callback;
      var server = (Math.floor(Math.random() * (this.nodes.length - 1 + 1)) + 1) - 1;
      this.host = this.nodes[server][0];
      this.port = this.nodes[server][1];
      this.openSocket(this.host, this.port);
      if (this.debugLevel > 0) {
        Logger.log('connecting to ' + this.host + ':' + this.port);
      }
    },

    openSocket: function(host, port) {
      var self = this;
      this.socket = new WebSocket('ws://' + host + ':' + port);

      this.socket.onopen = function(event) {
        self.reconnects = 0;
        var obj = {
          section: 'users',
          action: 'start',
          appid: self.appid,
          appsession: self.appsession,
          uid: self.userid,
        };
        self.sendObject(obj);
        this.switchingServer = false;
      };

      this.socket.onmessage = function(event) {
        var messageParts = event.data.split('!@');

        // There could be multiple messages or a partial message,
        // pass on complete messages and buffer any partial
        for (var i = 0; i < messageParts.length; i++) {
          self._message +=  messageParts[i];
          if (i < messageParts.length - 1) {
            if (self._message.indexOf('{') !== 0) {
              self._message = self._message.substring(self._message.indexOf('{'), self._message.length);
            }

            self.onMessage(self._message);
            self._message = '';
          }
        }
      };

      this.socket.onerror = function(event) {
        Logger.log('SMP: error' + event.data);
      };

      this.socket.onclose = function(event) {
        if (self.debugLevel > 0) {
          Logger.log('SMP: disconnected');
          Logger.log(event);
        }

        if (event.code == 4000) { self.timedout = true; }

        if (!self.switchingServer && !self.timedout) {
          self.reconnects = 1;
          self.startReconnect();
        }
      };
    },

    onMessage: function(msg) {
      try {
        var res = JSON.parse(msg);
        if (this.callback) {
          this.callback(res);
        }
      } catch (err) {
        Logger.log(err);
        return;
      }

      if (res.hasOwnProperty('action')) {
        if (res.section == 'users' && res.action == 'start' && res.errorcode == 0) {
          this.session = res.usersession;
          this.userid = res.userid;
          if (this.msgQue.length > 0) {
            for (var key in this.msgQue) {
              var msg = this.msgQue[key];
              this.sendObject(msg);
              if (this.debugLevel > 0) {
                Logger.log('sending que' + JSON.stringify(msg));
              }
            }

            this.msgQue = [];
          }
        }

        if (res.section == 'rooms' && res.action == 'playerjoined') {
          this.room.players[res.playerid] = res.meta;
        }

        if (res.section == 'rooms' && res.action == 'playerleft') {
          delete this.room.players[res.playerid];
        }

        if (res.section == 'rooms' && res.action == 'playerupdate') {
          this.room.players[res.playerid] = res.meta;
        }

        if (res.section == 'rooms' && res.action == 'join') {
          this.room = res.room;
        }

      } else {
        Logger.log('possible error ' + msg);
      }
    },

    roomList: function(type, roomid, custom, passthrough) {
      var options = { section: 'rooms', action: 'list', appid: this.appid };
      if (type) { options.type = type; }

      if (roomid) { options.roomid = roomid; }

      if (custom) { options.custom = custom; }

      if (passthrough) { options.pt = passthrough; }

      this.sendObject(options);
    },

    roomJoin: function(roomid, node, passthrough) {
      var nodep = node.split(':');
      var options = { section: 'rooms', action: 'join', appid: this.appid, roomid: roomid };
      if (passthrough) { options.pt = passthrough; }

      // If room is on different node, disconnect, store join message, and reconnect to new node
      // check last 3 port numbers to maintain dual socket parity with raw and web sockets.
      if (nodep[0] != this.host || nodep[1].substring(1) != this.port.toString().substring(1)) {
        this.host = nodep[0];
        this.port = nodep[1];
        this.switchServer(this.host, this.port);
        if (this.debugLevel > 0) {
          Logger.log('switch to ' + node);
        }

        this.msgQue.push(options);
      } else {
        this.sendObject(options);
      }
    },

    roomCreate: function(type, roomid, custom, passthrough, options) {
      var opt = { section: 'rooms', action: 'create', type: type, appid: this.appid };
      for (key in options) {
        opt[key] = options[key];
      }

      if (roomid) { opt.roomid = roomid; }

      if (custom) { opt.custom = custom; }

      if (passthrough) { opt.pt = passthrough; }

      this.sendObject(opt);
    },

    roomUpdate: function(custom, passthrough, options) {
      var opt = { section: 'rooms', action: 'update', appid: this.appid, custom: custom };
      if (passthrough) { opt.pt = passthrough; }

      for (key in options) {
        opt[key] = options[key];
      }

      this.sendObject(opt);
    },

    roomLeave: function(passthrough) {
      var options = { section: 'rooms', action: 'leave', appid: this.appid };
      if (passthrough) { options.pt = passthrough; }

      this.sendObject(options);
    },

    broadcast: function(message) {
      if (!message || typeof message !== 'object' || Array.isArray(message)) {
        Logger.log('SMP: broadcast takes an object for the argument');
      }

      this.sendObject({ section: 'rooms', action: 'broadcast', appid: this.appid, message: message });
    },

    broadcastAll: function(message) {
      if (!message || typeof message !== 'object' || Array.isArray(message)) {
        Logger.log('SMP: broadcast takes an object for the argument');
      }

      this.sendObject({ section: 'rooms', action: 'broadcast', appid: this.appid, message: message });
      this.callback({ section: 'rooms', action: 'broadcast', message: message, success: true, errorcode: 0 });
    },

    sendTo: function(userid, message) {
      this.sendObject({ section: 'rooms', action: 'sendTo', appid: this.appid, userid: userid, message: message });
    },

    userMeta: function(meta, passthrough) {
      var options = { section: 'users', action: 'meta', meta: meta, appid: this.appid };
      if (passthrough) { options.pt = passthrough; }

      this.sendObject(options);
    },

    ping: function(passthrough) {
      var options = { section: 'users', action: 'ping', appid: this.appid };
      if (passthrough) { options.pt = passthrough; }

      this.sendObject(options);
    },

    sendObject: function(obj) {
      var json = JSON.stringify(obj);
      this.socket.send(json);
      if (this.debugLevel > 1 && obj.action == 'broadcast') {
        Logger.log('SMP: sending ' + json);
      }

      if (this.debugLevel > 0 && obj.action != 'broadcast') {
        Logger.log('SMP: sending ' + json);
      }
    },

    switchServer: function(host, port) {
      this.switchingServer = true;
      this.socket.close();
      this.host = host;
      this.port = port;
      this.openSocket(host, port);
    },

    startReconnect: function() {
      var self = this;
      if (this.socket.readyState === 1) {
        this.reconnects = 0;
        Logger.log('SMP: reconnected');
        return;
      }

      if (this.socket.readyState === 0) {
        setTimeout(function() {
          self.reconnects++;
          self.startReconnect();
        }, 3000 * self.reconnects * 1.5);
        Logger.log('SMP: waiting for pending connection');
        return;
      }

      setTimeout(function() {
        Logger.log('SMP: Trying to reconnect');
        self.openSocket(self.host, self.port);
        self.reconnects++;
        self.startReconnect();
      }, 3000 * self.reconnects * 1.5);
    },

    api: function(options) {
      this.sendObject(options);
    },
  };
});

